namespace $ {
	export const $ink_currency_list = {
		aed: { symbol: 'د.إ' },
		afn: { symbol: '؋' },
		all: { symbol: 'L' },
		amd: { symbol: '֏' },
		ang: { symbol: 'ƒ' },
		aoa: { symbol: 'Kz' },
		ars: { symbol: '$' },
		aud: { symbol: '$' },
		awg: { symbol: 'ƒ' },
		azn: { symbol: '₼' },
		bam: { symbol: 'KM' },
		bbd: { symbol: '$' },
		bdt: { symbol: '৳' },
		bgn: { symbol: 'лв' },
		bhd: { symbol: '.د.ب' },
		bif: { symbol: 'FBu' },
		bmd: { symbol: '$' },
		bnd: { symbol: '$' },
		bob: { symbol: '$' + 'b' },
		bov: { symbol: 'BOV' },
		brl: { symbol: 'R$' },
		bsd: { symbol: '$' },
		btc: { symbol: '₿' },
		btn: { symbol: 'Nu.' },
		bwp: { symbol: 'P' },
		byn: { symbol: 'Br' },
		byr: { symbol: 'Br' },
		bzd: { symbol: 'BZ$' },
		cad: { symbol: '$' },
		cdf: { symbol: 'FC' },
		che: { symbol: 'CHE' },
		chf: { symbol: 'CHF' },
		chw: { symbol: 'CHW' },
		clf: { symbol: 'CLF' },
		clp: { symbol: '$' },
		cnh: { symbol: '¥' },
		cny: { symbol: '¥' },
		cop: { symbol: '$' },
		cou: { symbol: 'COU' },
		crc: { symbol: '₡' },
		cuc: { symbol: '$' },
		cup: { symbol: '₱' },
		cve: { symbol: '$' },
		czk: { symbol: 'Kč' },
		djf: { symbol: 'Fdj' },
		dkk: { symbol: 'kr' },
		dop: { symbol: 'RD$' },
		dzd: { symbol: 'دج' },
		eek: { symbol: 'kr' },
		egp: { symbol: '£' },
		ern: { symbol: 'Nfk' },
		etb: { symbol: 'Br' },
		eth: { symbol: 'Ξ' },
		eur: { symbol: '€' },
		fjd: { symbol: '$' },
		fkp: { symbol: '£' },
		gbp: { symbol: '£' },
		gel: { symbol: '₾' },
		ggp: { symbol: '£' },
		ghc: { symbol: '₵' },
		ghs: { symbol: 'GH₵' },
		gip: { symbol: '£' },
		gmd: { symbol: 'D' },
		gnf: { symbol: 'FG' },
		gtq: { symbol: 'Q' },
		gyd: { symbol: '$' },
		hkd: { symbol: '$' },
		hnl: { symbol: 'L' },
		hrk: { symbol: 'kn' },
		htg: { symbol: 'G' },
		huf: { symbol: 'Ft' },
		idr: { symbol: 'Rp' },
		ils: { symbol: '₪' },
		imp: { symbol: '£' },
		inr: { symbol: '₹' },
		iqd: { symbol: 'ع.د' },
		irr: { symbol: '﷼' },
		isk: { symbol: 'kr' },
		jep: { symbol: '£' },
		jmd: { symbol: 'J$' },
		jod: { symbol: 'JD' },
		jpy: { symbol: '¥' },
		kes: { symbol: 'KSh' },
		kgs: { symbol: 'лв' },
		khr: { symbol: '៛' },
		kmf: { symbol: 'CF' },
		kpw: { symbol: '₩' },
		krw: { symbol: '₩' },
		kwd: { symbol: 'KD' },
		kyd: { symbol: '$' },
		kzt: { symbol: '₸' },
		lak: { symbol: '₭' },
		lbp: { symbol: '£' },
		lkr: { symbol: '₨' },
		lrd: { symbol: '$' },
		lsl: { symbol: 'M' },
		ltc: { symbol: 'Ł' },
		ltl: { symbol: 'Lt' },
		lvl: { symbol: 'Ls' },
		lyd: { symbol: 'LD' },
		mad: { symbol: 'MAD' },
		mdl: { symbol: 'lei' },
		mga: { symbol: 'Ar' },
		mkd: { symbol: 'ден' },
		mmk: { symbol: 'K' },
		mnt: { symbol: '₮' },
		mop: { symbol: 'MOP$' },
		mro: { symbol: 'UM' },
		mru: { symbol: 'UM' },
		mur: { symbol: '₨' },
		mvr: { symbol: 'Rf' },
		mwk: { symbol: 'MK' },
		mxn: { symbol: '$' },
		mxv: { symbol: 'MXV' },
		myr: { symbol: 'RM' },
		mzn: { symbol: 'MT' },
		nad: { symbol: '$' },
		ngn: { symbol: '₦' },
		nio: { symbol: 'C$' },
		nok: { symbol: 'kr' },
		npr: { symbol: '₨' },
		nzd: { symbol: '$' },
		omr: { symbol: '﷼' },
		pab: { symbol: 'B/.' },
		pen: { symbol: 'S/.' },
		pgk: { symbol: 'K' },
		php: { symbol: '₱' },
		pkr: { symbol: '₨' },
		pln: { symbol: 'zł' },
		pyg: { symbol: 'Gs' },
		qar: { symbol: '﷼' },
		rmb: { symbol: '￥' },
		ron: { symbol: 'lei' },
		rsd: { symbol: 'Дин.' },
		rub: { symbol: '₽' },
		rwf: { symbol: 'R₣' },
		sar: { symbol: '﷼' },
		sbd: { symbol: '$' },
		scr: { symbol: '₨' },
		sdg: { symbol: 'ج.س.' },
		sek: { symbol: 'kr' },
		sgd: { symbol: 'S$' },
		shp: { symbol: '£' },
		sll: { symbol: 'Le' },
		sos: { symbol: 'S' },
		srd: { symbol: '$' },
		ssp: { symbol: '£' },
		std: { symbol: 'Db' },
		stn: { symbol: 'Db' },
		svc: { symbol: '$' },
		syp: { symbol: '£' },
		szl: { symbol: 'E' },
		thb: { symbol: '฿' },
		tjs: { symbol: 'SM' },
		tmt: { symbol: 'T' },
		tnd: { symbol: 'د.ت' },
		top: { symbol: 'T$' },
		trl: { symbol: '₤' },
		try: { symbol: '₺' },
		ttd: { symbol: 'TT$' },
		tvd: { symbol: '$' },
		twd: { symbol: 'NT$' },
		tzs: { symbol: 'TSh' },
		uah: { symbol: '₴' },
		ugx: { symbol: 'USh' },
		usd: { symbol: '$' },
		uyi: { symbol: 'UYI' },
		uyu: { symbol: '$' + 'U' },
		uyw: { symbol: 'UYW' },
		uzs: { symbol: 'лв' },
		vef: { symbol: 'Bs' },
		ves: { symbol: 'Bs.S' },
		vnd: { symbol: '₫' },
		vuv: { symbol: 'VT' },
		wst: { symbol: 'WS$' },
		xaf: { symbol: 'FCFA' },
		xbt: { symbol: 'Ƀ' },
		xcd: { symbol: '$' },
		xof: { symbol: 'CFA' },
		xpf: { symbol: '₣' },
		xsu: { symbol: 'Sucre' },
		xua: { symbol: 'XUA' },
		yer: { symbol: '﷼' },
		zar: { symbol: 'R' },
		zmw: { symbol: 'ZK' },
		zwd: { symbol: 'Z$' },
		zwl: { symbol: '$' },
	}
}
